import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App.tsx';
import store from './context/stores/rootStore';
import './assets/js/jquery-3.7.1.min.js'
import "./assets/js/bootstrap.js";
import './assets/css/bootstrap.min.css';
import $ from 'jquery';
import 'bootstrap';  
import './assets/css/bootstrap.less';
import 'devextreme/dist/css/dx.light.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/dashlite.css';
// import './assets/css/dxtable.css';
// import './assets/css/theme.css';
// import './assets/css/menu-v2.css';
import './assets/css/style-v2.css';
// import './assets/js/custom-v2.js';
// import './assets/js/menu-v2.js';



ReactDOM.createRoot(document.getElementById('root')!).render(
	// <React.StrictMode>
	<BrowserRouter>
		<Provider store={store}>
			<App />
		</Provider>
	</BrowserRouter>
	// </React.StrictMode>
);
